import {
  type AddressSuggestion,
  fetchTimezoneId,
  resolveAddressSuggestion,
  searchAddressSuggestions,
} from '../../../utils/googlePlacesAddress';
import type { PickedAddress } from './model';

export type { AddressSuggestion };

const apiKey = () => process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const searchAddresses = (query: string) =>
  searchAddressSuggestions(query, apiKey());

/** Place details for a picked suggestion; the restaurant address also gets its time zone. */
export async function resolveAddress(
  suggestion: AddressSuggestion,
  { withTimezone = false } = {},
): Promise<PickedAddress> {
  const parsed = await resolveAddressSuggestion(suggestion);
  const timezone =
    withTimezone && parsed.lat != null && parsed.lng != null
      ? await fetchTimezoneId(parsed.lat, parsed.lng, apiKey())
      : '';
  return {
    label: parsed.formattedAddress || suggestion.label,
    parts: {
      address_line_1: parsed.address_line_1,
      address_line_2: parsed.address_line_2,
      city: parsed.city,
      state: parsed.state,
      postal_code: parsed.postal_code,
      country: parsed.country,
      timezone,
    },
  };
}
